interface IsOfferLockedOutParams {
  offer: Offer;
  currentTime: Date;
}

export const isOfferLockedOut = (params: IsOfferLockedOutParams): boolean => {
  const { offer, currentTime } = params;

  if (!offer.lockoutUntilUtc || !currentTime) {
    return false;
  }

  // Ensure the lockout time is treated as UTC by appending 'Z' if not present.
  const lockoutTimeString = offer.lockoutUntilUtc.endsWith('Z')
    ? offer.lockoutUntilUtc
    : offer.lockoutUntilUtc + 'Z';

  const lockoutTime = new Date(lockoutTimeString);

  return currentTime <= lockoutTime;
};
